var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { ref: "qrContent", staticClass: "text-center p-2" }, [
    _vm.qrCodeValue
      ? _c("div", [
          _c("img", {
            attrs: {
              src: "/static/img/thai-qr-payment.png",
              alt: "",
              width: [_vm.$mq.phone ? "202" : "280"]
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { position: "relative" } },
            [
              _c("qrcode", {
                ref: "qrCodeImage",
                staticClass: "qr-code-image",
                attrs: {
                  value: _vm.qrCodeValue,
                  options: _vm.options,
                  id: "qrCodeImage",
                  tag: "img"
                }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "qr-code-logo",
                attrs: {
                  src: "/static/img/thai-qr-payment-logo-sm.png",
                  width: [_vm.$mq.phone ? "32" : "40"],
                  alt: ""
                }
              })
            ],
            1
          )
        ])
      : _c(
          "div",
          [
            _vm.displayLoading ? _c("loader") : _vm._e(),
            _vm._v(" "),
            _vm.promptpay
              ? _c("div", [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$i18n.locale === "th"
                          ? _vm.promptpay.remark_th
                          : _vm.promptpay.remark_en
                      ) +
                      "\n    "
                  )
                ])
              : _vm._e()
          ],
          1
        ),
    _vm._v(" "),
    _vm.qrCodeValue
      ? _c(
          "div",
          { staticClass: "pt-3" },
          [
            _c(
              "a",
              {
                staticClass: "text-primary-link",
                attrs: { href: "" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.loadQrCode(_vm.tmpQrPaymentData)
                  }
                }
              },
              [
                _c("i", { staticClass: "fas fa-redo" }),
                _vm._v(
                  " " + _vm._s(_vm.$t("message.button.refresh")) + "\n    "
                )
              ]
            ),
            _vm._v(" "),
            _c("vac", {
              ref: "countDownTimer",
              attrs: {
                "auto-start": true,
                "end-time": new Date().getTime() + 600000
              },
              on: {
                finish: function($event) {
                  return _vm.finishTimer()
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "process",
                    fn: function(ref) {
                      var timeObj = ref.timeObj
                      return [
                        _c("span", [
                          _vm._v(_vm._s(timeObj.m + ":" + timeObj.s))
                        ])
                      ]
                    }
                  },
                  {
                    key: "finish",
                    fn: function() {
                      return [
                        _c("span", { staticClass: "text-orange" }, [
                          _c("i", {
                            staticClass: "fa fa-exclamation-triangle"
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("message.promptpay.expired")) +
                              "\n        "
                          )
                        ])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                4179455051
              )
            }),
            _vm._v(" "),
            !_vm.isExpiredQrCode
              ? _c("div", { staticClass: "mt-3" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-info btn-block",
                      on: {
                        click: function($event) {
                          return _vm.downloadQrCode()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("message.button.download_qr_code")) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "pt-2 text-remark" }, [
                    _vm._v(_vm._s(_vm.$t("message.qr_payment.save_screenshot")))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3 text-left" }, [
              _c("span", { staticClass: "text-danger" }, [
                _c("i", { staticClass: "fa fa-exclamation-triangle" }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("message.my_reservations.remark")) +
                    ":\n      "
                )
              ]),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("message.qr_payment.remark")) +
                  "\n      "
              ),
              _c("div", { staticClass: "pt-3" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-info btn-block",
                    on: {
                      click: function($event) {
                        return _vm.contactAdmin()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("message.button.contact_admin")) +
                        "\n        "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("hr")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-left" }, [
              _vm.tmpQrPaymentData.orderId && _vm.order && _vm.qrPayment
                ? _c("section", [
                    _c("div", [
                      _vm.qrPayment.payment_for === "normal"
                        ? _c("span", [
                            _vm._v("#" + _vm._s(_vm.order.order_code))
                          ])
                        : _c("span", [
                            _vm._v(
                              "#" +
                                _vm._s(_vm.order.order_code) +
                                " - " +
                                _vm._s(
                                  _vm.$t(
                                    "message.my_reservations.additional_hours"
                                  )
                                )
                            )
                          ])
                    ]),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c("div", [
                      _vm.order.cleaning_date
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("message.booking.booking_step.date")
                                ) +
                                ": " +
                                _vm._s(
                                  _vm._f("prettyDate")(_vm.order.cleaning_date)
                                ) +
                                "\n          "
                            )
                          ])
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.booking.new_booking.booking_type_flexible"
                                )
                              )
                            )
                          ])
                    ]),
                    _vm._v(" "),
                    _c("hr")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.tmpQrPaymentData
                ? _c(
                    "div",
                    [
                      _vm.tmpQrPaymentData.user
                        ? _c("div", { staticClass: "mb-2" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.tmpQrPaymentData.user.full_name) +
                                "\n        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.tmpQrPaymentData.professionalRegisterPayment &&
                      _vm.tmpQrPaymentData.professionalRegisterPayment
                        .professional_register
                        ? [
                            _c("div", { staticClass: "mb-2" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.tmpQrPaymentData
                                      .professionalRegisterPayment
                                      .professional_register.firstname
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.tmpQrPaymentData
                                      .professionalRegisterPayment
                                      .professional_register.lastname
                                  ) +
                                  " (" +
                                  _vm._s(
                                    _vm.tmpQrPaymentData
                                      .professionalRegisterPayment
                                      .professional_register.id_card_number
                                  ) +
                                  ")\n          "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n            ค่าสมัคร: " +
                                  _vm._s(
                                    _vm._f("currency")(
                                      _vm.tmpQrPaymentData
                                        .professionalRegisterPayment
                                        .application_fee
                                    )
                                  ) +
                                  "\n          "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n            ค่าตรวจประวัติ: " +
                                  _vm._s(
                                    _vm._f("currency")(
                                      _vm.tmpQrPaymentData
                                        .professionalRegisterPayment
                                        .criminal_record_fee
                                    )
                                  ) +
                                  "\n          "
                              )
                            ])
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-2" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("message.service_request.all_amount_due")
                            ) +
                            ": "
                        ),
                        _c("b", [
                          _vm._v(
                            _vm._s(
                              _vm._f("currency")(_vm.tmpQrPaymentData.amount)
                            )
                          )
                        ])
                      ])
                    ],
                    2
                  )
                : _vm._e()
            ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c658ce4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c658ce4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/qrPayment/QrCodePayment.vue
// module id = 1750
// module chunks = 0